import { useParams } from 'react-router-dom'

import {
  TrainingRequestDetailFragment,
  TrainingRequestsEmployeesDocument,
} from 'generated/resources/graphql'

import { useFormContext } from 'modules/core/hooks/useForm'
import { useQuery } from 'modules/core/hooks/useQuery'

import { RequestType, UpdateData } from 'modules/trainings/pages/MyTrainings/RequestDetail/types'

import { FromCatalogComponent } from './FromCatalogComponent'
import { NewProposalComponent } from './NewProposalComponent'

interface Props {
  trainingRequest: TrainingRequestDetailFragment
  back: string
  selectedRequestType: RequestType
  setSelectedRequestType: (value: RequestType) => void
  isApprover?: boolean
  manageEmployee: boolean
}

export const RequestDetailComponent = ({
  trainingRequest,
  selectedRequestType,
  setSelectedRequestType,
  isApprover,
  manageEmployee,
}: Props) => {
  const { id } = useParams()

  const form = useFormContext<UpdateData>()
  const { data: employeesData } = useQuery(TrainingRequestsEmployeesDocument, {
    variables: { ids: form.values.employeeIds },
  })

  const disableForm = trainingRequest.status !== 'draft' && !isApprover
  const readonly =
    trainingRequest.status == 'approved' ||
    trainingRequest.status == 'rejected' ||
    !manageEmployee ||
    disableForm
  const onChangeTrainingType = (value: RequestType) => {
    if (value === 'newRequest') {
      form.setValues({ ...form.values, trainingId: undefined })
    }
    setSelectedRequestType(value)
  }

  return selectedRequestType === 'newRequest' ? (
    <NewProposalComponent
      onChangeTrainingType={onChangeTrainingType}
      id={id}
      form={form}
      selectedRequestType={selectedRequestType}
      trainingRequest={trainingRequest}
      readonly={readonly}
      employees={employeesData?.employees.employeeNames ?? []}
    />
  ) : (
    <FromCatalogComponent
      onChangeTrainingType={onChangeTrainingType}
      id={id}
      readonly={readonly}
      employees={employeesData?.employees.employeeNames ?? []}
      form={form}
      selectedRequestType={selectedRequestType}
      trainingRequest={trainingRequest}
    />
  )
}
